export const Answered = ({ props }) => ([
  { text: 'Gelesen', value: 'read_date:!=null' },
  { text: 'Ungelesen', value: 'read_date:::null' },
  { text: 'Erinnerung', value: `reminder_date:!=null` },
  { text: 'Beantwortet, nicht bestätigt', value: 'is_not_submitted:!=null' },
  { text: 'Beantwortet', value: 'answer_date:!=null' },
  { text: 'Nicht beantwortet', value: 'answer_date:::null' },
  { text: (props.settings?.poolRequestConfirmationOfReceipt || false) ? 'Bestätigt' : 'Formal korrekt', value: 'submit_date:!=null' },
  { text: 'Nicht bestätigt', value: 'submit_date:::null' },
  { text: 'Im LE Postfach', value: 'is_care_provider_inbox:!=null' },
])
